const storeEsls = {
    path: 'storeEsls',
    name: 'storeEsls',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'esl',
        icon: 'HSIconfont hs-icon-esl',
        showRealm: ['NORMAL']
    },
    children: [
        {
            path: 'storeEslFailed',
            name: 'storeEslFailed',
            component: () => import('@/views/storeEslFailed'),
            meta: { code: 'esl:failedList' }
        },
        {
            path: 'storeEslFirmware',
            name: 'storeEslFirmware',
            component: () => import('@/views/storeEslFirmware'),
            meta: { code: 'esl:firmware' }
        },
        {
            path: 'storeEslAllowEsl',
            name: 'storeEslAllowEsl',
            component: () => import('@/views/storeEslAllowEsl'),
            meta: { code: 'esl:allowEsl' }
        },
        {
            path: 'storeLockedEsl',
            name: 'storeLockedEsl',
            component: () => import('@/views/storeLockedEsl'),
            meta: { code: 'esl:disallowEsl' }
        },
    ]
};

export default storeEsls;
